import React from "react";
import {
  Flex,
} from "@chakra-ui/react";
import Individuals from "./components/Individuals"
const Data = () => {
  return (
    <Flex direction="column" pt={{ base: "62px", md: "75px", xl: "88px" }}>
      <Individuals />
    </Flex>
  );
}

export default Data;
